import ApiService from "@/common/api.service"

export const LevelOfStudiesService = {
    create(params) {
        return ApiService.post("levelOfStudies/add", params);
    },
    update(slug, params) {
        return ApiService.update("levelOfStudies", slug, params);
    },

}